"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerProfileModal = void 0;
const React = require("react");
const react_1 = require("react");
const RetailCustomerLogin_1 = require("../../checkout/RetailCustomerLogin");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const useClient_1 = require("../../../../../hooks/useClient");
const RetailCustomerResetPasswordRequest_1 = require("../../checkout/RetailCustomerResetPasswordRequest");
const Grid_1 = require("../../../../../components/base/structure/Grid");
const Img_1 = require("../../../../../components/base/atoms/Img");
const constants_1 = require("../../helpers/constants");
const constants_2 = require("../../../../../helpers/constants");
const RetailCustomer_1 = require("../../models/RetailCustomer");
const RetailCustomerVerifyAccount_1 = require("../../checkout/RetailCustomerVerifyAccount");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const styles = require("./styles.scss");
const css = (0, cssComposer_1.default)(styles, "RetailCustomerProfileModal");
if (env.orderingAppImageLink === undefined) {
    throw new Error("env.orderingAppImageLink not set");
}
const RetailCustomerProfileModal = ({ profileOpen, setProfileOpen }) => {
    const client = (0, useClient_1.useClient)();
    const [accountVerificationRetailCustomerDetails, setAccountVerificationRetailCustomerDetails] = (0, react_1.useState)(null);
    const { auth: { session } } = client;
    const { theme, orderingGooglePlayLink, orderingAppStoreLink, orderingAppImageLink } = env;
    const retailCustomer = (0, react_1.useMemo)(() => session && session.retailCustomer, [
        session
    ]);
    const [resetPasswordRequest, setResetPasswordRequest] = (0, react_1.useState)(false);
    const openAppLink = (url) => {
        if (!url) {
            alert("Application is currently unavailable.");
        }
        else {
            window.open(url, "_blank");
        }
    };
    const dismissModal = () => {
        setProfileOpen(false);
        setResetPasswordRequest(false);
    };
    const ProfileSection = (0, react_1.useMemo)(() => () => (React.createElement(React.Fragment, null,
        React.createElement(Grid_1.Grid, null,
            React.createElement("div", null,
                React.createElement("p", null, constants_1.text[theme][constants_1.TOrderingText.ProfileText]),
                React.createElement("div", { className: css("appBadges") },
                    React.createElement("div", { onClick: () => openAppLink(orderingGooglePlayLink) },
                        React.createElement(Img_1.Img, { className: css("appBadge"), src: constants_2.googlePlayBadge })),
                    React.createElement("div", { onClick: () => openAppLink(orderingAppStoreLink) },
                        React.createElement(Img_1.Img, { className: css("appBadge"), src: constants_2.appStoreBadge })))),
            React.createElement("div", null,
                React.createElement(Img_1.Img, { className: css("appImage"), src: orderingAppImageLink }))),
        React.createElement(Modal_1.ModalFooter, { onAccept: () => client.auth.logout(), acceptLabel: "log out" }))), [retailCustomer, theme, client]);
    const LoginSection = (0, react_1.useMemo)(() => () => (React.createElement(React.Fragment, null,
        !resetPasswordRequest && (React.createElement(React.Fragment, null, accountVerificationRetailCustomerDetails ? (React.createElement(RetailCustomerVerifyAccount_1.RetailCustomerVerifyAccount, { retailCustomerDetails: accountVerificationRetailCustomerDetails })) : (React.createElement(RetailCustomerLogin_1.RetailCustomerLogin, { onCompletion: retailCustomer => {
                if (retailCustomer) {
                    // if we get retail session, it means the customer has been already verified
                    if (retailCustomer instanceof RetailCustomer_1.RetailCustomer) {
                        // activate account verification modal
                        // if we only receive the customer data (not the session one)
                        // then, we need to ask the customer to verify their phone number first
                        setAccountVerificationRetailCustomerDetails({
                            retailCustomerId: retailCustomer.id,
                            mobileNumber: retailCustomer.mobileNumber
                        });
                        // then, resend a verification SMS message to customer's phone number
                        client.retailCustomers
                            .resendVerificationCode(retailCustomer.id)
                            .catch(console.warn);
                    }
                }
            } },
            React.createElement("a", { className: css("resetPasswordLink"), onClick: () => setResetPasswordRequest(true) }, "Forgot your password?"))))),
        resetPasswordRequest && React.createElement(RetailCustomerResetPasswordRequest_1.RetailCustomerResetPasswordRequest, null))), [resetPasswordRequest, accountVerificationRetailCustomerDetails]);
    return (React.createElement(Modal_1.Modal, { open: profileOpen, onClose: dismissModal, size: dialogs_1.TDialogSizes.Medium, showCloseIcon: true, appMode: true },
        React.createElement(Modal_1.ModalHeader, null, "Profile"),
        React.createElement(Modal_1.ModalBody, null, session ? React.createElement(ProfileSection, null) : React.createElement(LoginSection, null))));
};
exports.RetailCustomerProfileModal = RetailCustomerProfileModal;
//# sourceMappingURL=index.js.map